<template>
    <div
        class="l-ss-c-offer-params-wrapper"
        :class="{ 'l-ss-c-offer-params-wrapper-color': isColorParams }">
        <div class="l-ss-c-offer-params-title">{{ title }}</div>
        <div class="l-ss-c-offer-params-items">
            <div
                v-for="(item, i) in items"
                :key="i"
                class="l-ss-c-offer-params-item"
                :style="{ backgroundColor: isColorParams ? parseColorParam(item).colorValue : '' }"
                :class="{
                    'l-ss-c-offer-params-item-active': item === value,
                    'l-ss-c-offer-params-item-disabled': item !== value && !availableItems.includes(item)
                }"
                @click.prevent.stop="changeParam(item)">
                {{ !isColorParams ? item : '' }}
            </div>
        </div>
    </div>
</template>

<script>
    import parseColorParam from '@/core/helpers/parse-color-param';

    export default {
        props: {
            value: {
                type: String,
            },
            title: {
                type: String,
            },
            items: {
                type: Array,
            },
            availableItems: {
                type: Array,
                default: () => [],
            },
        },
        setup(props, { emit, root }) {
            const changeParam = (param) => {
                emit('input', param);
                emit('change', param);
            };

            const isColorParams = props.title === 'Цвет' && root.$configuration.shouldParseColor;

            return {
                changeParam,
                isColorParams,
                parseColorParam,
            };
        },
    };
</script>
